import { takeLatest } from 'redux-saga/effects'
import { PUBLISH_WHITELABEL } from 'app/redux-base/actions/configurator'
import publishWL from './publishWL'

export default function* watchUpdatePreview() {
  yield takeLatest(PUBLISH_WHITELABEL.REQUEST, publishWL)
}
